<template>
  <div class="block-documents">
    <div v-if="documents && documents.length" class="block-documents__list">
      <document-card
          v-for="document in documents"
          :key="document.id"
          :name="document.name"
          :url="document.url"
      />
    </div>
    <div v-else class="block-documents__empty">
      Документы отсутствуют
    </div>
  </div>
</template>

<script>
import DocumentCard from "@/components/common/components/DocumentCard.vue";

export default {
  name: "DetailedProjectDocuments",
  components: {DocumentCard},
  props: {
    documents: {
      type: Array,
      required: true,
      validator: (docs) => docs.every(doc => typeof doc.id === 'number' && typeof doc.name === 'string' && typeof doc.url === 'string')
    }
  }
};
</script>

<style lang="scss" scoped>
.block-documents__list {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  max-width: 40rem;
}

.block-documents__empty {
  color: var(--secondary-gray);
  padding: 1rem 0;
}
</style>
